/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CriteriaCategory } from './CriteriaCategory';
import {
    CriteriaCategoryFromJSON,
    CriteriaCategoryFromJSONTyped,
    CriteriaCategoryToJSON,
    CriteriaCategoryToJSONTyped,
} from './CriteriaCategory';

/**
 * 
 * @export
 * @interface CreateCriteriaCategory201Response
 */
export interface CreateCriteriaCategory201Response {
    /**
     * 
     */
    data?: CriteriaCategory;
}

/**
 * Check if a given object implements the CreateCriteriaCategory201Response interface.
 */
export function instanceOfCreateCriteriaCategory201Response(value: object): value is CreateCriteriaCategory201Response {
    return true;
}

export function CreateCriteriaCategory201ResponseFromJSON(json: any): CreateCriteriaCategory201Response {
    return CreateCriteriaCategory201ResponseFromJSONTyped(json, false);
}

export function CreateCriteriaCategory201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCriteriaCategory201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CriteriaCategoryFromJSON(json['data']),
    };
}

export function CreateCriteriaCategory201ResponseToJSON(json: any): CreateCriteriaCategory201Response {
    return CreateCriteriaCategory201ResponseToJSONTyped(json, false);
}

export function CreateCriteriaCategory201ResponseToJSONTyped(value?: CreateCriteriaCategory201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CriteriaCategoryToJSON(value['data']),
    };
}

